/** Only instants are formatted. Business-date labels must remain date-only strings. */
export function formatAccountingInstant(
  value: string,
  timezone: string,
  locale = 'en',
  options: { precision?: 'minute' | 'second'; businessDate?: string } = {},
): string | null {
  if (
    !/^\d{4}-\d{2}-\d{2}T.*(?:Z|[+-]\d{2}:\d{2})$/i.test(value) ||
    !Number.isFinite(Date.parse(value)) ||
    !timezone
  )
    return null;
  try {
    // Fixed numeric parts avoid locale-dependent calendars, AM/PM and midnight 24:00.
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: timezone,
      calendar: 'gregory',
      numberingSystem: 'latn',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
      timeZoneName: 'longOffset',
    }).formatToParts(new Date(value));
    const part = (type: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === type)!.value;
    const date = `${part('year')}-${part('month')}-${part('day')}`;
    const time = `${part('hour')}:${part('minute')}${options.precision === 'second' ? `:${part('second')}` : ''}`;
    const zh = locale.toLowerCase().startsWith('zh');
    const zone = timezone === 'Asia/Taipei' ? (zh ? '台北' : 'Taipei') : part('timeZoneName');
    return `${options.businessDate === date ? '' : `${date} `}${time}${zh ? `（${zone}）` : ` (${zone})`}`;
  } catch {
    return null;
  }
}
